import { styled } from "@mui/material";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useProcessingOrder } from "../hooks/useProcessingOrder";
import { useFormikContext } from "formik";
import ModalWithReasons from "./ModalWithReasons";
import { useOrderAttributeProvider } from "../context/order";
import Error from "./Error";
import { PAYMENT_METHODS } from "Helpers/Constants";
import { useCustomer } from "Context/Customer/useCustomer";
const useStyles = styled({
  btn: {
    width: "123px",
    height: "50px",
    fontWeight: "bold",
    textTransform: "none",
    fontSize: 20,
    color: "#fff",
    "&:hover, &:focus": {
      color: "#fff !important",
      backgroundColor: "#c2887b",
    },
  },
});
const Submit = () => {
  //PAYABLI
  const { customerState, setPaymentMethodNonce } = useCustomer();
  const classes = useStyles();
  const formik = useFormikContext();
  const {
    modal,
    setModal,
  } = useOrderAttributeProvider();
  const { showErrorModal, processOrder, setShowErrorModal } =
    useProcessingOrder();
  const handleProcessOrder = () => {
    if(formik.values.order_type_identifier == 1 && 
      (!Boolean(formik.values.refund_reason.reason_type_id) && 
      !Boolean(formik.values.refund_reason.reason_subtype_id))){
      setModal("replace-reason");
    }else{
      processOrder()
    }
  }
  const handleReplaceOrder = ( ) => {
    const refundReason = formik.values?.refund_reason;
    if (refundReason?.reason_type_id && refundReason?.reason_subtype_id) {
      setModal("");
      processOrder();
    }
  }
  //PAYABLI
  useEffect(() => {
    if(formik.isValid && formik.values.payment_type === "credit_card" 
        && customerState.paymentNonce){
      //Create new order with credit card payment method and payabli
      formik.values.order_type_identifier
        ? handleProcessOrder()
        : processOrder();
      setPaymentMethodNonce(null);
    }
  }, [customerState.paymentNonce && formik.values.payment_type === "credit_card"]);

  //PAYABLI
  const handlePayabliProcessOrder = () => {
    if(!formik.isValid){
      formik.submitForm();
      setShowErrorModal(true);
      setPaymentMethodNonce(null);
    } else if(formik.isValid && formik.values.payment_type === "credit_card" 
        && !customerState.paymentNonce){
      window.payabliInstance.payabliExec("method");
    }else if(formik.isValid && formik.values.payment_type !== "credit_card"){
      formik.values.order_type_identifier
      ? handleProcessOrder()
      : processOrder();
      setPaymentMethodNonce(null);
    }
  }

  return (
    <>
      <div className="text-center my-4">
        <Error
          open={showErrorModal}
          handleClose={() => setShowErrorModal(false)}
        />
        {/* //PAYABLI */}
        <Button
          sx={{
            padding: "10px 40px",
          }}
          type="button"
          className={classes.btn}
          variant="contained"
          color="primary"
          size="large"
          onClick={handlePayabliProcessOrder}
        >
          Save
        </Button>
      </div>
      <ModalWithReasons
        showModal={modal === "replace-reason"}
        handleCancelClick={() => {
          setModal("")
          formik.setValues({
            ...formik.values,
            refund_reason: {
              ...formik.values.refund_reason,
              reason_type_id: null,
              reason_subtype_id: null,
            },
          });
        }}
        handleSubmitClick={handleReplaceOrder}
        pageTitle="Replace Order"
        placeholder="replacing"
      />
    </>
  );
};

export default Submit;
